import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

import Label from './Label';

const fieldLabelVariants = cva('', {
  variants: {
    variant: {
      small: '-ml-2 pl-2 text-sm font-normal tracking-normal',
      medium: 'ml-0 pl-0 text-base font-semibold tracking-[-0.03em]',
    },
  },
});

export type FieldLabelProps = ComponentProps<typeof Label> &
  VariantProps<typeof fieldLabelVariants>;

const FieldLabel = ({ className, variant, ...props }: FieldLabelProps) => {
  return (
    <Label
      data-slot="field-label"
      className={cn(
        'group/field-label peer/field-label flex w-fit gap-2',
        'has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col has-[>[data-slot=field]]:rounded-xs has-[>[data-slot=field]]:border *:data-[slot=field]:p-2.5',
        'group-has-[>[role=checkbox]]/field:cursor-pointer group-has-[>[role=radio]]/field:cursor-pointer group-has-[>[role=switch]]/field:cursor-pointer',
        'group-data-[disabled=true]/field:cursor-not-allowed',
        !variant && [
          // checkbox, radio, switch auto typography behavior
          'group-has-[>[role=checkbox]]/field:text-sm group-has-[>[role=radio]]/field:text-sm group-has-[>[role=switch]]/field:text-sm',
          'group-has-[>[role=checkbox]]/field:font-normal group-has-[>[role=radio]]/field:font-normal group-has-[>[role=switch]]/field:font-normal',
          'group-has-[>[role=checkbox]]/field:tracking-normal group-has-[>[role=radio]]/field:tracking-normal group-has-[>[role=switch]]/field:tracking-normal',
          'group-has-[>[role=checkbox]]/field:-ml-2 group-has-[>[role=radio]]/field:-ml-2 group-has-[>[role=switch]]/field:-ml-2',
          'group-has-[>[role=checkbox]]/field:pl-2 group-has-[>[role=radio]]/field:pl-2 group-has-[>[role=switch]]/field:pl-2',
        ],
        variant && fieldLabelVariants({ variant }),

        // disabled
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]/field:opacity-25',

        // choice cards
        'has-data-checked:border-gray-900/30 has-data-checked:bg-gray-900/5',
        className,
      )}
      {...props}
    />
  );
};

export default FieldLabel;
